// import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
// import '@fancyapps/ui/dist/fancybox/fancybox.css';

const lightBox = () => {
    Fancybox.bind("[data-fancybox]", {
        Carousel: {
            Toolbar: {
                display: {
                    left: ["counter"],
                    right: ["zoomIn", "zoomOut", "close"]
                }
            },
        }
    });
}

export default lightBox